import React from 'react';
import { Zap } from 'lucide-react';
export function UniqueMechanism() {
  return <section className="bg-dark-bg text-white py-20 px-4 md:px-8 relative overflow-hidden" data-id="element-117">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-orange/10 blur-[120px] rounded-full pointer-events-none" data-id="element-118"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-119">
        <div className="inline-flex items-center justify-center p-4 bg-dark-surface rounded-full mb-8 border border-brand-orange/30" data-id="element-120">
          <Zap className="w-8 h-8 text-brand-orange" data-id="element-121" />
        </div>
        <h2 className="font-oswald text-3xl md:text-5xl font-bold mb-8 uppercase" data-id="element-122">
          Presentamos el Protocolo de{' '}
          <span className="text-brand-orange" data-id="element-123">Reset Metabólico</span>
        </h2>
        <div className="font-inter text-lg md:text-xl text-gray-300 space-y-6 leading-relaxed text-left max-w-3xl mx-auto" data-id="element-124">
          <p data-id="element-125">
            A diferencia de las dietas tradicionales, este plan de 14 días se
            enfoca en apagar el interruptor de la Insulina.
          </p>
          <p data-id="element-126">
            Al elegir los alimentos <strong data-id="element-127">"Alpha"</strong> correctos,
            obligamos a tu cuerpo a dejar de usar azúcar y empezar a usar tu
            propia grasa abdominal como combustible.
          </p>
          <p className="text-white font-semibold text-xl md:text-2xl text-center mt-8 border-y border-gray-800 py-8" data-id="element-128">
            No es magia, es bioquímica aplicada para que recuperes tu talle de
            pantalón mientras dormís.
          </p>
        </div>
      </div>
    </section>;
}